import React from "react";
import { withGlobalSettings } from "../../../hocs/withGlobalSettings";

const SunbitInviteSnippet = ({ globalSettings }) => {
  const isSunbitFeatureEnabled = globalSettings?.feature_flag?.sunbit || false;

  return isSunbitFeatureEnabled ? (
    <p>
      <b>Sunbit Invite:</b>
      {`{{SUNBITINVITE}}`}{" "}
    </p>
  ) : (
    <></>
  );
};

export default withGlobalSettings(SunbitInviteSnippet);
